import React from 'react';
import PropTypes from 'prop-types';

const Edit04 = ({color = 'currentColor', ...props}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7707 1.08925C11.0959 0.763787 11.6234 0.763565 11.949 1.08875L13.9102 3.04772C14.2359 3.37304 14.2361 3.90081 13.9107 4.2264L5.6125 12.5291C5.49643 12.6453 5.34864 12.7245 5.18769 12.757L1.5 13.5L2.24437 9.8167C2.27684 9.65608 2.35593 9.50859 2.47178 9.39268L10.7707 1.08925Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
  </svg>
);

Edit04.propTypes = {
  color: PropTypes.string,
};

export default Edit04;
